module.exports = __webpack_public_path__ + "pcstatic/img/book1.bae8bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book1.png
// module id = cZvM
// module chunks = 28